export default __webpack_public_path__ + "static/media/email.09f59b22.svg";